export const SPECIAL_TYPE = 'P';
export const MAX_LEN_SEARCH = 2;
export const ONLY_HAVE_ONE_ROW = 1;
export const NEGATIVE_STATUS = ['Rechazado', 'Negado', 'Eliminado', 'Facturado'];
export const ALL_AGENCIES = {'key': 'TODAS', 'text': 'TODAS', 'value': 'TODAS'};
export const PROCESSES = {
  '01': 'PEDIDO REALIZADO DEALER',
  '02': 'PEDIDO PROCESADO TDE',
  '03': 'FACTURACIÓN PROVEEDOR',
  '04': 'ENVIO PROVEEDOR',
  '05': 'ADUANA',
  '06': 'CPD TDE',
  '07': 'FACTURACION A DEALER',
};
